import { render, staticRenderFns } from "./LomPresidentList.vue?vue&type=template&id=3811a4a2"
import script from "./LomPresidentList.vue?vue&type=script&lang=js"
export * from "./LomPresidentList.vue?vue&type=script&lang=js"
import style0 from "./LomPresidentList.vue?vue&type=style&index=0&id=3811a4a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports